import type { ReservationAccordionState } from '@/wabunka-src/common/features/Reservation/core/accordion/accordionState';
import type { ReservationSectionId } from '@/wabunka-src/common/features/Reservation/core/requiredFields/sections';

export interface ReservationSectionCompletedEvent {
  sectionId: ReservationSectionId;
  isAutoCompleted: boolean;
}

export interface ReservationSectionGaEventState {
  /** 日時を変えただけで数え直さないよう、記録は体験で区切る */
  experienceId: string;
  viewedSectionIds: ReservationSectionId[];
  completedSectionIds: ReservationSectionId[];
}

export interface ReservationSectionGaEventPlan {
  completedEvents: ReservationSectionCompletedEvent[];
  viewedSectionId: ReservationSectionId | null;
  nextState: ReservationSectionGaEventState;
}

export const createDefaultReservationSectionGaEventState = (): ReservationSectionGaEventState => ({
  experienceId: '',
  viewedSectionIds: [],
  completedSectionIds: [],
});

/** 着地時点で通過済みのセクション（3DS からの復帰など）はこの画面で完了したものではないため、記録だけして送らない */
export const planReservationSectionGaEvents = (
  experienceId: string,
  previous: ReservationAccordionState | undefined,
  next: ReservationAccordionState,
  state: ReservationSectionGaEventState,
): ReservationSectionGaEventPlan => {
  const isSameExperience = state.experienceId === experienceId;
  const viewedSectionIds = isSameExperience ? state.viewedSectionIds : [];
  const completedSectionIds = isSameExperience ? state.completedSectionIds : [];

  const passedSectionIds = next.visitedSectionIds.filter((sectionId) => !completedSectionIds.includes(sectionId));
  // Continue は開いているセクションにしか無いため、直前に開いていたセクション以外は自動完了で通過したもの
  const continuedSectionId = previous?.openSectionId;
  const completedEvents = previous === undefined ? [] : passedSectionIds.map((sectionId) => ({ sectionId, isAutoCompleted: sectionId !== continuedSectionId }));
  const viewedSectionId = viewedSectionIds.includes(next.openSectionId) ? null : next.openSectionId;

  return {
    completedEvents,
    viewedSectionId,
    nextState: {
      experienceId,
      viewedSectionIds: viewedSectionId === null ? viewedSectionIds : [...viewedSectionIds, viewedSectionId],
      completedSectionIds: [...completedSectionIds, ...passedSectionIds],
    },
  };
};
